<template>
<div>

  <logo-view></logo-view>

  <router-view/>
  
<footer-view></footer-view>


</div>
</template>
<script>
import FooterView from './views/FooterView.vue'
import LogoView from './views/LogoView.vue'


export default {
  components: { FooterView,LogoView },
  
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

</style>
